<template>
    <div id="ProgressHeader">
        <div class="container py-2">
            <progress-header-step
                class="d-inline-block"
                :label="$t('components.coach_search_form.progress_bar.step1')"
                :is-completed="isRouteInfoComplete"
                :is-clickable="true"
                :is-active="currentRoute === 'business-travel-management.index'"
                route="business-travel-management.index"
            />

            <br class="d-sm-block d-md-none" />

            <div class="d-inline-block">
                <font-awesome-icon icon="chevron-right" />
            </div>

            <progress-header-step
                class="d-inline-block"
                :label="$t('components.coach_search_form.progress_bar.step2')"
                :is-completed="isRouteInfoComplete && isTravelOptionsComplete"
                :is-clickable="isRouteInfoComplete"
                :is-active="currentRoute === 'business-travel-management.travel-options'"
                route="business-travel-management.travel-options"
            />

            <br class="d-sm-block d-md-none" />

            <div class="d-inline-block">
                <font-awesome-icon icon="chevron-right" />
            </div>

            <progress-header-step
                class="d-inline-block"
                :label="$t('components.coach_search_form.progress_bar.step4')"
                :is-completed="isRouteInfoComplete && isTravelOptionsComplete && isContactComplete"
                :is-clickable="isContactComplete"
                :is-active="currentRoute === 'business-travel-management.contact'"
                route="business-travel-management.contact"
            />

            <br class="d-sm-block d-md-none" />

            <div class="d-inline-block">
                <font-awesome-icon icon="chevron-right" />
            </div>

            <progress-header-step
                class="d-inline-block"
                :label="$t('components.coach_search_form.progress_bar.step5')"
                :is-completed="false"
                :is-clickable="isRouteInfoComplete && isTravelOptionsComplete && isContactComplete"
                :is-active="currentRoute === 'business-travel-management.summary'"
                route="business-travel-management.summary"
            />
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import ProgressHeaderStep from '@components/ProgressHeaderStep';

    export default {
        components: {
            ProgressHeaderStep,
        },

        data() {
            return {
                currentRoute: this.$router.currentRoute.name,
            };
        },

        computed: {
            ...mapGetters({
                isRouteInfoComplete: 'businessTravelManagement/getIsRouteInfoComplete',
                isTravelOptionsComplete: 'businessTravelManagement/getIsTravelOptionsComplete',
                isContactComplete: 'businessTravelManagement/getIsContactComplete',
            }),
        },
    };
</script>
